/* Esternal */
import { all, select, race, take, call } from "redux-saga/effects";
import { addSeconds } from "date-fns";

/* Actions */
import { baseActionName } from "./actions";
import { actionTypes as epgFiltersActionTypes } from "../filters/actions";
import { actionTypes as allStationsActionTypes } from "../../allStations/actions";

/* Services */
import { backendService } from "../../../services";

/* Other */
import { makeFetchSaga, TIME_ZONE, EPG, UNFINISHED_STATUS_TYPES } from "../../../utils";

function* getEntitledStationsSlice(offset) {
  // get all stations data
  const { data = [], status: allStationsStatus } = yield select(({ allStations = {} }) => allStations);
  let allStationsData = data;

  if (UNFINISHED_STATUS_TYPES.some((status) => status === allStationsStatus)) {
    yield race({
      allStationsSuccess: take(allStationsActionTypes.SUCCESS),
      allStationsFailure: take(allStationsActionTypes.FAILURE)
    });

    const { data = [] } = yield select(({ allStations = {} }) => allStations);
    allStationsData = data;
  }

  if (!allStationsData.length) throw new Error("allStations load has failed!");

  // get filters data
  const { data: epgFiltersData, status: epgFiltersStatus = "" } = yield select(({ epg = {} }) => epg.filters);
  let filtersData = epgFiltersData;

  if (UNFINISHED_STATUS_TYPES.some((status) => status === epgFiltersStatus)) {
    yield race({
      allStationsSuccess: take(epgFiltersActionTypes.SUCCESS),
      allStationsFailure: take(epgFiltersActionTypes.FAILURE)
    });

    const { data: epgFiltersData = [] } = yield select(({ epg = {} }) => epg.filters);
    filtersData = epgFiltersData;
  }

  if (!filtersData.length) throw new Error("epg filter load has failed!");

  // get slice
  const activeFilterStations = filtersData.find((filter) => filter.active)?.stations || [];

  if (!activeFilterStations.length) throw new Error("epg filter data is empty!");

  const entitledStations = allStationsData.filter((station) => station && station.entitled);
  const filteredEntitledStations = entitledStations.filter(({ id = "" }) => activeFilterStations.includes(id));

  return filteredEntitledStations.slice(offset, offset + EPG.STATIONS_TO_LOAD);
}

function* getStationsWithSchedules(fromDatetime, toDatetime, offset) {
  const {
    data: { stations: prevStationsWithSchedules = [] }
  } = yield select(({ epg = {} }) => epg.stationsWithSchedules);
  const stations = yield getEntitledStationsSlice(offset);

  if (stations.length) {
    const { data: schedules = [] } = yield call(backendService.content.getSchedules, {
      count: EPG.MAX_SCHEDULES_PER_REQUEST,
      fromDatetime: addSeconds(fromDatetime, 1),
      language: "*",
      region: TIME_ZONE,
      schedulesTypes: "",
      stationIDs: stations.map(({ id = "" }) => id),
      toDatetime: addSeconds(toDatetime, 1)
    });

    const newStationsWithSchedules = stations
      .map((station) => ({
        ...station,
        ...schedules.find((schedule) => station.id === schedule.stationId)
      }))
      .filter((station) => station.schedules);

    return { data: { stations: [...prevStationsWithSchedules, ...newStationsWithSchedules], stopRequesting: false } };
  }

  return { data: { stations: prevStationsWithSchedules, stopRequesting: true } };
}

const getStationsWithSchedulesSagas = makeFetchSaga(baseActionName, {
  func: getStationsWithSchedules,
  getParams: ({ fromDatetime = "", toDatetime = "", offset = 0 }) => [fromDatetime, toDatetime, offset]
});

export default function* epg() {
  yield all([getStationsWithSchedulesSagas]);
}
